module.exports = __webpack_public_path__ + "img/14.6fc39b98.jpg";